import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { epicsErrorHandler } from '../../epics'

import { saveLastSeenProductReleaseError, saveLastSeenProductReleaseSuccess } from './actions'
import { LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC } from './constants'

const saveLastSeenProductReleaseEpic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC.INITIATE),
    mergeMap(() =>
      api.accounts.saveLastSeenProductRelease().pipe(
        map(() => saveLastSeenProductReleaseSuccess()),
        catchError((error) => of(epicsErrorHandler(saveLastSeenProductReleaseError, error)))
      )
    )
  )

export default combineEpicsIsolated(saveLastSeenProductReleaseEpic)
